(function () {
  var bundleSelector = "[data-compatible-bundle-products]";
  var itemSelector = "[data-compatible-bundle-item]";
  var inputSelector = ".xo-compatible-bundle-products__input";
  var minusSelector = "[data-compatible-bundle-quantity-minus]";
  var plusSelector = "[data-compatible-bundle-quantity-plus]";
  var buyFormSelector = ".xo-product-info-content__buy-form";
  var loadingClass = "xo-btn--loading";
  var mainLabelSelector = "[data-compatible-bundle-main-label]";
  var mainTotalSelector = "[data-compatible-bundle-main-total]";
  var accessoriesTotalSelector = "[data-compatible-bundle-accessories-total]";
  var finalTotalSelector = "[data-compatible-bundle-final-total]";
  var summarySelector = "[data-compatible-bundle-summary]";
  var progressTextSelector = "[data-compatible-bundle-progress-text]";
  var progressFillSelector = "[data-compatible-bundle-progress-fill]";
  var milestoneSelector = "[data-compatible-bundle-milestone]";
  var buyNowSelector = ".xo-product-info-content__buy-now";
  var paymentButtonSelector = ".shopify-payment-button__button, .shopify-payment-button button, [data-testid='Checkout-button'], button[name='checkout']";

  function getRootRoute() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }

    return "/";
  }

  function getCheckoutUrl() {
    return getRootRoute() + "checkout";
  }

  function getMoneyFormat(bundle) {
    var useCurrencyCode = bundle && bundle.getAttribute("data-use-currency-code") === "true";
    var currencyFormat = document.documentElement.getAttribute("xo-money-with-currency-format");
    var moneyFormat = document.documentElement.getAttribute("xo-money-format");

    return useCurrencyCode ? currencyFormat || moneyFormat || "{{amount}}" : moneyFormat || "{{amount}}";
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    var value = (number / 100).toFixed(precision);
    var parts = value.split(".");
    var dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    var cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  function stripHtml(value) {
    var element = document.createElement("span");

    element.innerHTML = value;

    return element.textContent || element.innerText || value;
  }

  function formatMoney(cents, bundle) {
    var amount = Number(cents) || 0;
    var format = getMoneyFormat(bundle);
    var placeholderMatch = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var placeholder = placeholderMatch ? placeholderMatch[1] : "amount";
    var formattedAmount = "";

    switch (placeholder) {
      case "amount_no_decimals":
        formattedAmount = formatWithDelimiters(amount, 0, ",", ".");
        break;
      case "amount_with_comma_separator":
        formattedAmount = formatWithDelimiters(amount, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        formattedAmount = formatWithDelimiters(amount, 0, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        formattedAmount = formatWithDelimiters(amount, 2, "'", ".");
        break;
      default:
        formattedAmount = formatWithDelimiters(amount, 2, ",", ".");
        break;
    }

    return stripHtml(format.replace(placeholderMatch ? placeholderMatch[0] : "{{amount}}", formattedAmount));
  }

  function getCartSections() {
    var cartMini = document.querySelector("xo-cart-mini");

    if (cartMini && cartMini.id) {
      return [cartMini.id];
    }

    return [];
  }

  function clampQuantity(value, max) {
    var quantity = Number(value);
    var maxQuantity = Number(max);

    if (!quantity || Number.isNaN(quantity)) {
      quantity = 0;
    }

    quantity = Math.max(0, Math.floor(quantity));

    if (max !== null && max !== "" && !Number.isNaN(maxQuantity)) {
      quantity = Math.min(quantity, Math.max(0, maxQuantity));
    }

    return quantity;
  }

  function getItemMax(item) {
    if (!item || !item.hasAttribute("data-max")) {
      return null;
    }

    return item.getAttribute("data-max");
  }

  function getItemQuantity(item) {
    var input = item && item.querySelector(inputSelector);

    return input ? clampQuantity(input.value, getItemMax(item)) : 0;
  }

  function setItemQuantity(item, quantity) {
    var input = item && item.querySelector(inputSelector);
    var nextQuantity = clampQuantity(quantity, getItemMax(item));

    if (input) {
      input.value = nextQuantity;
    }

    return nextQuantity;
  }

  function getBundleItems(bundle) {
    return Array.from(bundle.querySelectorAll(itemSelector)).map(function (item) {
      var quantity = getItemQuantity(item);

      return {
        id: Number(item.getAttribute("data-variant-id")),
        quantity: quantity,
        productId: item.getAttribute("data-product-id") || "",
        price: Number(item.getAttribute("data-price")) || 0
      };
    }).filter(function (item) {
      return item.id && !Number.isNaN(item.id) && item.quantity > 0;
    });
  }

  function getProgressTextHtml(quantity) {
    if (quantity >= 3) {
      return "<span class=\"xo-compatible-bundle-products__highlight\">%15</span> bundle indirimini kazandın!";
    }

    if (quantity === 2) {
      return "2 ürün ekledin. %15 indirim için <span class=\"xo-compatible-bundle-products__highlight\">1 ürün</span> daha ekle.";
    }

    if (quantity === 1) {
      return "1 ürün ekledin. %15 indirim için <span class=\"xo-compatible-bundle-products__highlight\">2 ürün</span> daha ekle.";
    }

    return "Henüz ürün eklemedin. %15 indirim için <span class=\"xo-compatible-bundle-products__highlight\">3 ürün</span> daha ekle.";
  }

  function getDiscountTier(quantity) {
    if (quantity >= 3) {
      return 15;
    }

    if (quantity === 2) {
      return 10;
    }

    if (quantity === 1) {
      return 5;
    }

    return 0;
  }

  function updateProgress(bundle, selectedCount) {
    var progressText = bundle.querySelector(progressTextSelector);
    var progressFill = bundle.querySelector(progressFillSelector);
    var progressPercent = Math.min(selectedCount, 3) / 3 * 100;

    if (progressText) {
      progressText.innerHTML = getProgressTextHtml(selectedCount);
    }

    if (progressFill) {
      progressFill.style.width = progressPercent + "%";
    }

    Array.from(bundle.querySelectorAll(milestoneSelector)).forEach(function (milestone) {
      var milestoneQuantity = Number(milestone.getAttribute("data-compatible-bundle-milestone")) || 0;

      milestone.classList.toggle("is-achieved", selectedCount >= milestoneQuantity);
    });
  }

  function updateItemState(item) {
    var quantity = setItemQuantity(item, getItemQuantity(item));
    var max = getItemMax(item);
    var minusButton = item.querySelector(minusSelector);
    var plusButton = item.querySelector(plusSelector);
    var maxQuantity = Number(max);

    item.classList.toggle("is-selected", quantity > 0);
    item.setAttribute("data-compatible-bundle-quantity", quantity);

    if (minusButton) {
      minusButton.disabled = quantity <= 0;
    }

    if (plusButton) {
      plusButton.disabled = max !== null && max !== "" && !Number.isNaN(maxQuantity) && quantity >= maxQuantity;
    }
  }

  function getProductData(productElement) {
    var dataElement = productElement && productElement.querySelector("xo-product-data");
    var template = dataElement && dataElement.querySelector("template");
    var text = "";

    if (template) {
      text = template.content.textContent || "";
    } else if (dataElement) {
      text = dataElement.textContent || "";
    }

    if (!text.trim()) {
      return null;
    }

    try {
      return JSON.parse(text);
    } catch (error) {
      try {
        return JSON.parse(text.replace(/,\s*([}\]])/g, "$1"));
      } catch (parseError) {
        return null;
      }
    }
  }

  function getCurrentVariantId(productElement, form) {
    var productId = productElement && productElement.getAttribute("xo-product-id");
    var sectionId = productElement && productElement.getAttribute("xo-section-id");
    var cartFormState = typeof window.getCartFormState === "function" ? window.getCartFormState() : null;
    var stateKey = sectionId && productId ? sectionId + "/" + productId : "";
    var stateVariantId = stateKey && cartFormState && cartFormState[stateKey] && cartFormState[stateKey].variantId;

    if (stateVariantId) {
      return Number(stateVariantId);
    }

    var formVariantInput = form && form.querySelector('[name="id"]');

    if (formVariantInput && formVariantInput.value) {
      return Number(formVariantInput.value);
    }

    var selectedVariantId = productElement && productElement.getAttribute("xo-selected-or-first-available-variant-id");

    if (selectedVariantId) {
      return Number(selectedVariantId);
    }

    var productData = getProductData(productElement);
    var firstAvailableVariant = productData && productData.variants && productData.variants.find(function (variant) {
      return variant.available;
    });

    return firstAvailableVariant ? Number(firstAvailableVariant.id) : 0;
  }

  function getCurrentMainPrice(productElement, form, bundle) {
    var variantId = getCurrentVariantId(productElement, form);
    var productData = getProductData(productElement);
    var variant = productData && productData.variants && productData.variants.find(function (item) {
      return Number(item.id) === Number(variantId);
    });

    if (variant && typeof variant.price === "number") {
      return variant.price;
    }

    return Number(bundle.getAttribute("data-main-price")) || 0;
  }

  function getMainQuantity(buyForm, form, productElement) {
    var quantityInput = buyForm.querySelector('.xo-product-info-content__quantity input[name="quantity"]') || (form && form.querySelector('input[name="quantity"]'));
    var quantity = quantityInput ? Number(quantityInput.value) : 1;
    var productId = productElement && productElement.getAttribute("xo-product-id");
    var sectionId = productElement && productElement.getAttribute("xo-section-id");
    var cartFormState = typeof window.getCartFormState === "function" ? window.getCartFormState() : null;
    var stateKey = sectionId && productId ? sectionId + "/" + productId : "";
    var stateQuantity = stateKey && cartFormState && cartFormState[stateKey] && cartFormState[stateKey].quantity;

    if (!quantity || Number.isNaN(quantity)) {
      quantity = Number(stateQuantity) || 1;
    }

    return Math.max(1, quantity);
  }

  function normalizePropertyName(name) {
    return name.replace(/^properties\[/, "").replace(/\]$/, "");
  }

  function collectMainProperties(productElement) {
    var properties = {};
    var fields = productElement ? Array.from(productElement.querySelectorAll('input[name^="properties["], textarea[name^="properties["], select[name^="properties["]')) : [];

    fields.forEach(function (field) {
      if (field.disabled) {
        return;
      }

      if ((field.type === "checkbox" || field.type === "radio") && !field.checked) {
        return;
      }

      if (!field.value) {
        return;
      }

      properties[normalizePropertyName(field.name)] = field.value;
    });

    return Object.keys(properties).length ? properties : null;
  }

  function collectMainSellingPlan(productElement, form) {
    var sellingPlanInput = (form && form.querySelector('input[name="selling_plan"], select[name="selling_plan"]')) || (productElement && productElement.querySelector('input[name="selling_plan"], select[name="selling_plan"]'));

    return sellingPlanInput && sellingPlanInput.value ? sellingPlanInput.value : "";
  }

  function setLoading(trigger, isLoading) {
    var button = trigger.querySelector("button");

    trigger.toggleAttribute("xo-loading", isLoading);

    if (button) {
      button.classList.toggle(loadingClass, isLoading);
      button.disabled = isLoading;
    }
  }

  function setBundleLoading(bundle, isLoading) {
    var wrapper = bundle && bundle.closest(".xo-compatible-bundle-products");

    if (wrapper) {
      wrapper.classList.toggle("is-loading", isLoading);
    }
  }

  function setBuyNowLoading(trigger, isLoading) {
    var buyNow = trigger && trigger.closest && trigger.closest(buyNowSelector);
    var paymentButtons = buyNow ? Array.from(buyNow.querySelectorAll(paymentButtonSelector)) : [];

    if (buyNow) {
      buyNow.toggleAttribute("data-compatible-bundle-buy-now-loading", isLoading);
      buyNow.setAttribute("aria-busy", isLoading ? "true" : "false");
    }

    paymentButtons.forEach(function (button) {
      if (button instanceof HTMLButtonElement) {
        if (isLoading) {
          button.setAttribute("data-compatible-bundle-was-disabled", button.disabled ? "true" : "false");
          button.disabled = true;
        } else {
          button.disabled = button.getAttribute("data-compatible-bundle-was-disabled") === "true";
          button.removeAttribute("data-compatible-bundle-was-disabled");
        }
      }

      button.classList.toggle(loadingClass, isLoading);
      button.setAttribute("aria-busy", isLoading ? "true" : "false");
    });
  }

  function isBuyNowLoading(trigger) {
    var buyNow = trigger && trigger.closest && trigger.closest(buyNowSelector);

    return !!(buyNow && buyNow.hasAttribute("data-compatible-bundle-buy-now-loading"));
  }

  function buildMainItem(productElement, form, buyForm) {
    var mainVariantId = getCurrentVariantId(productElement, form);
    var mainQuantity = getMainQuantity(buyForm, form, productElement);

    if (!mainVariantId || Number.isNaN(mainVariantId)) {
      return null;
    }

    var mainItem = {
      id: mainVariantId,
      quantity: mainQuantity
    };
    var mainProperties = collectMainProperties(productElement);
    var mainSellingPlan = collectMainSellingPlan(productElement, form);

    if (mainProperties) {
      mainItem.properties = mainProperties;
    }

    if (mainSellingPlan) {
      mainItem.selling_plan = mainSellingPlan;
    }

    return mainItem;
  }

  function buildBundleCartItems(mainItem, selectedAccessories) {
    return [mainItem].concat(selectedAccessories.map(function (item) {
      return {
        id: item.id,
        quantity: item.quantity
      };
    }));
  }

  function updateBundleState(bundle) {
    if (!bundle) {
      return;
    }

    var buyForm = bundle.closest(buyFormSelector);
    var productElement = bundle.closest("xo-product");
    var form = buyForm && (buyForm.querySelector('form[action*="/cart/add"]') || buyForm.querySelector("form"));
    var selectedAccessories = getBundleItems(bundle);
    var selectedCount = selectedAccessories.reduce(function (total, item) {
      return total + item.quantity;
    }, 0);
    var mainQuantity = buyForm ? getMainQuantity(buyForm, form, productElement) : 1;
    var mainPrice = getCurrentMainPrice(productElement, form, bundle);
    var accessoryTotal = selectedAccessories.reduce(function (total, item) {
      return total + item.price * item.quantity;
    }, 0);
    var mainTotal = mainPrice * mainQuantity;
    var finalTotal = mainTotal + accessoryTotal;
    var discountTier = getDiscountTier(selectedCount);
    var mainLabel = bundle.querySelector(mainLabelSelector);
    var mainTotalEl = bundle.querySelector(mainTotalSelector);
    var accessoriesTotalEl = bundle.querySelector(accessoriesTotalSelector);
    var finalTotalEl = bundle.querySelector(finalTotalSelector);
    var summaryEl = bundle.querySelector(summarySelector);

    if (mainLabel) {
      mainLabel.textContent = "Ana ürün x " + mainQuantity;
    }

    if (mainTotalEl) {
      mainTotalEl.textContent = formatMoney(mainTotal, bundle);
    }

    if (accessoriesTotalEl) {
      accessoriesTotalEl.textContent = formatMoney(accessoryTotal, bundle);
    }

    if (finalTotalEl) {
      finalTotalEl.textContent = formatMoney(finalTotal, bundle);
    }

    if (summaryEl) {
      summaryEl.textContent = selectedCount ? "Sepete eklenecek: Ana ürün + " + selectedCount + " ek ürün" + (discountTier ? " (tahmini %" + discountTier + " indirim)" : "") : "Sepete eklenecek: Ana ürün";
    }

    updateProgress(bundle, selectedCount);

    Array.from(bundle.querySelectorAll(itemSelector)).forEach(function (item) {
      updateItemState(item);
    });
  }

  function updateContainingBundle(target) {
    var bundle = target && target.closest && target.closest(bundleSelector);

    if (bundle) {
      updateBundleState(bundle);
      return;
    }

    var productElement = target && target.closest && target.closest("xo-product");

    if (!productElement) {
      return;
    }

    Array.from(productElement.querySelectorAll(bundleSelector)).forEach(updateBundleState);
  }

  function updateAllBundles() {
    Array.from(document.querySelectorAll(bundleSelector)).forEach(updateBundleState);
  }

  function setCartStateSuccess(data, addedQuantity, productIds) {
    if (!window.xoStore || typeof window.xoStore.set !== "function") {
      return;
    }

    window.xoStore.set("xo-cart", function (previousState) {
      var currentSize = previousState && typeof previousState.size === "number" ? previousState.size : 0;

      return Object.assign({}, previousState, {
        size: currentSize + addedQuantity,
        sections: data.sections || {},
        items: data.items || [],
        addIdLoading: "",
        addErrorMessage: "",
        isAdded: true,
        productIdsForCartNotification: productIds
      });
    })("compatible-bundle-products/addCartSuccess");
  }

  function setCartStateFailure(message) {
    if (!window.xoStore || typeof window.xoStore.set !== "function") {
      return;
    }

    window.xoStore.set("xo-cart", function (previousState) {
      return Object.assign({}, previousState, {
        addIdLoading: "",
        addErrorMessage: message,
        isAdded: false,
        variantId: ""
      });
    })("compatible-bundle-products/addCartFailure");
  }

  function showError(message) {
    if (!message) {
      return;
    }

    if (window.xoToast && typeof window.xoToast.push === "function") {
      window.xoToast.push({
        content: message,
        className: "xo-cart-add-error",
        placement: "top-center",
        delay: 4000
      });
      return;
    }

    if (typeof window.xoToast === "function") {
      window.xoToast({
        content: message,
        className: "xo-cart-add-error",
        placement: "top-center",
        duration: 4000
      });
    }
  }

  async function addItems(items) {
    var sections = getCartSections();
    var body = {
      items: items
    };

    if (sections.length) {
      body.sections = sections;
      body.section_url = window.location.pathname;
    }

    var response = await fetch(getRootRoute() + "cart/add.js", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify(body)
    });

    var data = await response.json();

    if (!response.ok || data.status || data.errors) {
      throw data;
    }

    return data;
  }

  async function handleBundleAdd(event, trigger, buyForm, bundle) {
    var selectedAccessories = getBundleItems(bundle);

    if (!selectedAccessories.length) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (trigger.hasAttribute("xo-disabled") || trigger.hasAttribute("xo-loading")) {
      return;
    }

    var productElement = trigger.closest("xo-product");
    var form = trigger.closest('form[action*="/cart/add"]') || buyForm.querySelector('form[action*="/cart/add"]');
    var mainItem = buildMainItem(productElement, form, buyForm);

    if (!mainItem) {
      return;
    }

    var mainProductId = bundle.getAttribute("data-main-product-id") || "";

    if (form && !form.reportValidity()) {
      return;
    }

    var items = buildBundleCartItems(mainItem, selectedAccessories);
    var productIds = [mainProductId].concat(selectedAccessories.map(function (item) {
      return item.productId;
    })).filter(Boolean);
    var addedQuantity = items.reduce(function (total, item) {
      return total + item.quantity;
    }, 0);

    try {
      setLoading(trigger, true);
      setBundleLoading(bundle, true);
      var data = await addItems(items);

      setCartStateSuccess(data, addedQuantity, productIds);

      if (window.xoModal && typeof window.xoModal.open === "function") {
        window.xoModal.open("cart");
      }
    } catch (error) {
      var message = error && (error.description || error.message || error.errors) || (window.cartStrings && window.cartStrings.error) || "Unable to add items to cart.";

      if (Array.isArray(message)) {
        message = message.join(" ");
      }

      setCartStateFailure(message);
      showError(message);
    } finally {
      setLoading(trigger, false);
      setBundleLoading(bundle, false);
      updateBundleState(bundle);
    }
  }

  async function handleBundleBuyNow(event, trigger, buyForm, bundle) {
    var selectedAccessories = getBundleItems(bundle);

    if (!selectedAccessories.length) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (isBuyNowLoading(trigger)) {
      return;
    }

    var productElement = trigger.closest("xo-product");
    var form = trigger.closest('form[action*="/cart/add"]') || buyForm.querySelector('form[action*="/cart/add"]');
    var mainItem = buildMainItem(productElement, form, buyForm);

    if (!mainItem) {
      return;
    }

    if (form && !form.reportValidity()) {
      return;
    }

    try {
      setBuyNowLoading(trigger, true);
      setBundleLoading(bundle, true);
      await addItems(buildBundleCartItems(mainItem, selectedAccessories));

      window.location.href = getCheckoutUrl();
    } catch (error) {
      var message = error && (error.description || error.message || error.errors) || (window.cartStrings && window.cartStrings.error) || "Unable to add items to cart.";

      if (Array.isArray(message)) {
        message = message.join(" ");
      }

      console.error("Compatible bundle Buy Now failed", error);
      setCartStateFailure(message);
      showError(message);
      setBuyNowLoading(trigger, false);
      setBundleLoading(bundle, false);
      updateBundleState(bundle);
    }
  }

  document.addEventListener("click", function (event) {
    var quantityButton = event.target && event.target.closest && event.target.closest(minusSelector + ", " + plusSelector);

    if (quantityButton) {
      var item = quantityButton.closest(itemSelector);
      var bundle = quantityButton.closest(bundleSelector);
      var currentQuantity = getItemQuantity(item);
      var delta = quantityButton.matches(plusSelector) ? 1 : -1;

      event.preventDefault();
      event.stopPropagation();
      setItemQuantity(item, currentQuantity + delta);
      updateBundleState(bundle);
      return;
    }

    var buyNowTrigger = event.target && event.target.closest && event.target.closest(paymentButtonSelector);

    if (buyNowTrigger && buyNowTrigger.closest(buyNowSelector)) {
      var buyNowForm = buyNowTrigger.closest(buyFormSelector);
      var buyNowBundle = buyNowForm && buyNowForm.querySelector(bundleSelector);

      if (buyNowForm && buyNowBundle) {
        handleBundleBuyNow(event, buyNowTrigger, buyNowForm, buyNowBundle);
      }

      return;
    }

    var trigger = event.target && event.target.closest && event.target.closest("xo-cart-add");

    if (!trigger) {
      return;
    }

    var buyForm = trigger.closest(buyFormSelector);

    if (!buyForm) {
      return;
    }

    var bundle = buyForm.querySelector(bundleSelector);

    if (!bundle) {
      return;
    }

    handleBundleAdd(event, trigger, buyForm, bundle);
  }, true);

  document.addEventListener("submit", function (event) {
    var form = event.target;
    var buyNow = form && form.closest && form.closest(buyNowSelector);

    if (!buyNow) {
      return;
    }

    var buyForm = buyNow.closest(buyFormSelector);
    var bundle = buyForm && buyForm.querySelector(bundleSelector);
    var trigger = buyNow.querySelector(paymentButtonSelector) || form;

    if (buyForm && bundle && getBundleItems(bundle).length) {
      handleBundleBuyNow(event, trigger, buyForm, bundle);
    }
  }, true);

  document.addEventListener("change", function (event) {
    updateContainingBundle(event.target);
  });

  document.addEventListener("input", function (event) {
    if (event.target && event.target.matches && event.target.matches(inputSelector)) {
      var item = event.target.closest(itemSelector);

      setItemQuantity(item, event.target.value);
    }

    updateContainingBundle(event.target);
  });

  document.addEventListener("click", function (event) {
    window.requestAnimationFrame(function () {
      updateContainingBundle(event.target);
    });
  });

  updateAllBundles();

  if (typeof window.cartFormSubscribe === "function") {
    try {
      window.cartFormSubscribe(updateAllBundles);
    } catch (error) {
      updateAllBundles();
    }
  }
})();
